import { STATUS_MAP } from "../../constants";

export default function StatusBadge({ status }) {
  const s = STATUS_MAP[status];
  return <span style={{ background: s.bg, color: s.color, padding: "4px 10px", borderRadius: 8, fontSize: 11, fontWeight: 700 }}>{s.label}</span>;
}
